import React, { useEffect, useState } from "react";
import { Box, Stack, TextField, Paper, Button, Typography, Chip } from "@mui/material";
import Dropdown from "./common/Dropdown";
import ToggleButton from "./common/ToggleButton";
import ButtonGroup from "./common/ButtonGroup";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import DataGrid from "./common/DataGrid";

const MainForm = () => {
  const [form, setForm] = useState({
    company: "",
    card: "",
    account: "",
    orderId: "",
    card_usage_value : "",
    isHold: false,
  });


  const [companies, setCompanies] = useState([]);
  const [cards, setCards] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [card_usage_value, setCardUsage] = useState("");

  useEffect(() => {
    axios.get("https://oms-be.shreetradingcompany.in/api/get-company/", {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => setCompanies(res.data));
    axios.get("https://oms-be.shreetradingcompany.in/api/get-uncards", {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => setCards(res.data));
    axios.get("https://oms-be.shreetradingcompany.in/api/accounts/shopsy/True", {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => setAccounts(res.data));
  }, []);

  const swapCard = () => {
    axios.get("https://oms-be.shreetradingcompany.in/api/get-uncards", {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => setCards(res.data));
    setForm({ ...form, card: cards });
  };


  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } catch (err) {
      toast.error("Copy failed!");
    }
  };

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleHold = () => {
    const updated = !form.isHold;

    console.log(form)
    let url = "";
    if (!form.isHold)
      url = "https://oms-be.shreetradingcompany.in/api/hold/" + form.card.card_id;
    else
      url = "https://oms-be.shreetradingcompany.in/api/unhold/" + form.card.card_id;

    axios.post(url, {}, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(response => {
      toast.success(response.data['success_message'])
      setForm({ ...form, isHold: updated });
    })
      .catch(error => {
        toast.error(error.response.data['error_message']);
      });
  };

  const handleSave = () => {
    if(form.card_usage_value == "")
    {
      toast.error("Please select card usage");
      return
    }
    if(form.orderId == "")
    {
      toast.error("Please enter order id before saving");
      return
    }
    
    axios.post("https://oms-be.shreetradingcompany.in/api/mark-used/", {
       "card_number" : form.card.card_number,
      "card_status": form.card_usage_value,
      "order_number" : form.orderId,
      "order_vendor" : "shopsy",
      "account_id" : form.account.account_id,
      "company_id" : form.company.company_id
    },{
      headers : {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => {
      console.log("Saved:", res.data);
      toast.success(res.data['success_message'])
      setForm({company : form.company,card : "",account : form.account,orderId : "",isHold : false})
    });
  };

  const handleCancel = () => {
    setForm({ company: "", card: "", account: "", orderId: "", isHold: false });
  };

  return (
    <>
      <Stack sx={{ display: 'flex', flexDirection: 'row' }} spacing={2}>
        <Stack sx={{ width: '40%' }}>

          <Paper elevation={3} sx={{ p: 2, ml: 2, mt: 2, borderRadius: 1 }}>
            <Toaster />
            <Box component="form" noValidate autoComplete="off">
              <Stack spacing={3}>
                <Dropdown
                  label="Select Company"
                  value={form.company}
                  options={companies}
                  onChange={(value) => handleChange("company", value)}
                  getOptionLabel={(opt) => `${opt.company_name} - ${opt.company_pincode}`}
                  getOptionValue={(opt) => opt}
                />
                <Dropdown
                  label="Select Account"
                  value={form.account}
                  options={accounts}
                  onChange={(value) => handleChange("account", value)}
                  getOptionLabel={(opt) => `${opt.account_email} - ${opt.account_vendor}`}
                  getOptionValue={(opt) => opt}
                />
                {/* <Stack direction={{ xs: "column", sm: "row" }} spacing={2}> */}
                <Dropdown
                  label="Select Card"
                  value={form.card}
                  options={cards}
                  onChange={(value) => handleChange("card", value)}
                  getOptionLabel={(opt) => `${opt.card_number} - Rs.${opt.card_amount}`}
                  getOptionValue={(opt) => opt}
                />
                {/* <ToggleButton on={form.isToggled} onClick={handleToggle} /> */}
                {/* </Stack> */}
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <ToggleButton on={!form.isHold} onClick={handleHold}  />
                  <Button onClick={swapCard} title="Swap Card" variant="outlined">Swap Card</Button>
                </Stack>

                <TextField
                  size="small"
                  label="Order ID"
                  value={form.orderId}
                  onChange={(e) => handleChange("orderId", e.target.value)}
                  fullWidth
                />
                <Dropdown
                label="Card Usage Option"
                value={form.card_usage_value}
                options={[
                  { value: "used_success", label: "Success" },
                  { value: "used_but_error", label: "Error" },
                ]}
                onChange={(value) => handleChange("card_usage_value", value)}
                getOptionLabel={opt => opt.label}
                getOptionValue={opt => opt.value}
                />
                <ButtonGroup onSave={handleSave} onCancel={handleCancel} />
              </Stack>
            </Box>
          </Paper>
          {(form.card.card_number != null || form.card.card_number != undefined) &&
            <Paper elevation={3} sx={{ p: 2, pl: 1, ml: 2, mt: 2, borderRadius: 1 }}>

              <Box sx={{ display: "flex" }}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>

                  <Chip label={"Card Number : " + form.card.card_number} onClick={() => handleCopy(form.card.card_number)} color="primary" variant="outlined" />
                  <Chip label={"Expiry : " + form.card.card_expiry} onClick={() => handleCopy(form.card.card_expiry)} color="primary" variant="outlined" />
                  <Chip label={"CVV : " + form.card.card_cvv} onClick={() => handleCopy(form.card.card_cvv)} color="primary" variant="outlined" />

                </Stack>
              </Box>

            </Paper>

          }
        </Stack>
        <div style={{ height: '80vh', width: '80%' }}>
          <DataGrid
            columnDefs={[
              { field: 'order_number' },
              { field: 'product_name' },
              { field: 'buying_price' },
              { field: 'account' },
              { field: 'card_number' },
              { field: 'card_expiry' },
              { field: 'card_amount' }
            ]}
            apiEndpoint="https://oms-be.shreetradingcompany.in/api/orders-summary/"
            height="80vh"
            sx={{ width: '80%' }}
          />
        </div>
      </Stack>
    </>
  );
};

export default MainForm;
